// The user object the app keeps in UserContext, built from /user-info/. One builder for the login
// screen and the account switcher (plan v2 E3) — a switched session must look exactly like a
// fresh login to the account it switched to.

export const roleFromUserInfo = (info) => {
  if (info.is_superuser) return 'superuser';
  if (info.is_oem_master) return 'oem_master';
  if (info.is_ecc) return 'ecc';
  if (info.company === 'Vestas') return info.is_company_admin ? 'adminves' : 'userves';
  return info.is_company_admin ? 'admin' : 'user';
};

export const dashboardPathFor = (role) => {
  switch (role) {
    case 'oem_master':
      return '/oem'; // OEM Master ma osobny layout
    case 'ecc':
      return '/ecc'; // ECC ma osobny layout
    default:
      return '/dashboard'; // superuser i wszystkie inne role -> unified dashboard
  }
};

export const buildUserData = (info, accessToken) => ({
  id: info.id,
  username: info.username,
  role: roleFromUserInfo(info),
  company: info.company,
  isEcc: info.is_ecc || false,
  isOemMaster: info.is_oem_master || false,
  isAdmin: info.is_company_admin || false,
  isCoordinator: info.is_coordinator || false,
  menuPermissions: info.company_role_menu_permissions || [],
  hasCompanyRole: info.has_company_role === true,
  canEditUsers: info.can_edit_users !== false,
  canChangeCompanySettings: info.can_change_company_settings !== false,
  // Known from the first screen after login, not only once /users/{id}/ answers —
  // otherwise the board would render editable for a beat before the role arrives.
  resourceBoardActions: info.resource_board_actions || [],
  canDecideHolidays: info.can_decide_holidays === true,
  approvesLeave: info.approves_leave === true,
  sidebarPreferences: info.sidebar_preferences || {},
  // Plan v2 E2/E3: the kind of account this session is in, and whether a company account has
  // the person's private account linked yet.
  accountKind: info.account_kind || 'company',
  hasPrivateAccount: info.has_private_account === true,
  accessToken,
});
